import { Institution } from './enums'
import { type Language, languageEnumToBasename } from './localization'

export const buildUrl = (url: string, params: Record<string, string | string[]>) => {
  const result = new URL(url)
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => result.searchParams.append(`${key}`, item))
    } else {
      result.searchParams.append(key, value)
    }
  })
  return result.toString()
}

export const getRootDomain = (url: string) => {
  try {
    const { hostname } = new URL(url)
    return hostname.split('.').slice(-2).join('.')
  } catch {
    return 'faceup.com'
  }
}

export const generateShortIdUrl = (
  url: string,
  shortId: string | null,
  institution: Institution | null,
  language: string | null = null,
  isCheck = false
) => {
  const shortIdPath = `${language ? `/${languageEnumToBasename(language)}` : ''}/${
    institution === Institution.School ? 's' : 'c'
  }/${shortId ?? ''}${isCheck ? '/check' : ''}`

  return `${url}${shortIdPath}`
}

export const generateSurveyUrl = (url: string, shortId: string | null, language?: Language) => {
  const surveyPath = `${language ? `/${languageEnumToBasename(language)}` : ''}/q/${shortId ?? ''}`

  return `${url}${surveyPath}`
}

export const generateDisclosureUrl = (url: string, shortId: string | null, language?: Language) => {
  const disclosurePath = `${language ? `/${languageEnumToBasename(language)}` : ''}/d/${shortId ?? ''}`

  return `${url}${disclosurePath}`
}

const stubBase = 'https://example.com/'
/**
 * When you just want to create the path, not the whole URL.
 * I'm using the stubBase, so I can use the buildUrl which uses URL which needs the domain part.
 */
export const buildPath = (base: string, params: Record<string, string | string[]>) =>
  buildUrl(`${stubBase}${base}`, params).replace(stubBase, '')
